import '../../styles-new/pages/context/columnist-author.scss';

document.addEventListener('DOMContentLoaded', () => {
  const loadMoreBtn = document.querySelector('.author-block__load-more');
  const authorBody = document.querySelector('.author-block__body');

  if (loadMoreBtn && authorBody) {
    loadMoreBtn.addEventListener('click', () => {
      authorBody.classList.add('author-block__body-active');
    });
  }
});
